import { render, staticRenderFns } from "./IlluminatedSignage.vue?vue&type=template&id=4e51388e&scoped=true&"
import script from "./IlluminatedSignage.vue?vue&type=script&lang=ts&"
export * from "./IlluminatedSignage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e51388e",
  null
  
)

export default component.exports